import React, { useState } from "react";
import { toast } from "sonner";
import { Loader2, Send } from "lucide-react";
import api from "../lib/api";

export default function ContactForm() {
  const [form, setForm] = useState({ full_name: "", email: "", phone: "", subject: "General Inquiry", message: "" });
  const [loading, setLoading] = useState(false);
  const onChange = (k, v) => setForm((p) => ({ ...p, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/contact", form);
      toast.success(data.message || "Message received. Thank you.");
      setForm({ full_name: "", email: "", phone: "", subject: "General Inquiry", message: "" });
    } catch (err) {
      toast.error(err?.response?.data?.detail?.toString?.() || "Could not send. Please call us.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} className="bg-[#0c0c0c] border border-white/10 p-8 md:p-10" data-testid="contact-form">
      <div className="label-eyebrow mb-2">Send Us A Message</div>
      <h3 className="font-display text-2xl md:text-3xl text-white mb-6">How can we help?</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <input className="lux-input" required placeholder="Full Name" value={form.full_name} onChange={(e) => onChange("full_name", e.target.value)} data-testid="contact-name" />
        <input className="lux-input" placeholder="Phone" value={form.phone} onChange={(e) => onChange("phone", e.target.value)} data-testid="contact-phone" />
        <input type="email" className="lux-input md:col-span-2" required placeholder="Email" value={form.email} onChange={(e) => onChange("email", e.target.value)} data-testid="contact-email" />
        <input className="lux-input md:col-span-2" placeholder="Subject" value={form.subject} onChange={(e) => onChange("subject", e.target.value)} data-testid="contact-subject" />
        <textarea rows={5} required className="lux-input md:col-span-2" placeholder="Your message…" value={form.message} onChange={(e) => onChange("message", e.target.value)} data-testid="contact-message" />
      </div>
      <button type="submit" disabled={loading} className="btn-accent mt-6 w-full justify-center" data-testid="contact-submit">
        {loading ? <Loader2 className="animate-spin" size={16} /> : <Send size={16} />}
        {loading ? "Sending…" : "Send Message"}
      </button>
    </form>
  );
}
